// extracted by mini-css-extract-plugin
module.exports = {"s1he5ml8":"s1he5ml8","s1f6t1aa":"s1f6t1aa"};